import { IScheduleActivityResourceCategory } from '../../interfaces/ischedule-activity-resource-category';
import { ResourceCategory } from '../resource-category';
import { ScheduleActivity } from '../schedule-activity';

export class ScheduleActivityResourceCategoryBase {
  ScheduleActivityResourceCategoryId: number;
  ProjectPhaseStepResourceCategoryId: number;
  ResourceCategoryId: number | null;
  ScheduleActivityId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ResourceCategory?: ResourceCategory;
  ScheduleActivity?: ScheduleActivity;

  constructor(item?: IScheduleActivityResourceCategory) {
    if (item) {

      this.ScheduleActivityResourceCategoryId = item.ScheduleActivityResourceCategoryId;
      this.ProjectPhaseStepResourceCategoryId = item.ProjectPhaseStepResourceCategoryId;
      this.ResourceCategoryId = item.ResourceCategoryId;
      this.ScheduleActivityId = item.ScheduleActivityId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ResourceCategory = new ResourceCategory(item.ResourceCategory);
      this.ScheduleActivity = new ScheduleActivity(item.ScheduleActivity);
    }
  }
}